module.exports = __webpack_public_path__ + "d335b1f7842c183f2626026980bb59d7.svg";